// Cabecera de página del módulo Administración y del Calendario sobre
// las clases que ya existen (`.page-header*`, dashboard.css): eyebrow
// mono, h1 de 26px, bajada de 14px con tope de 640px y acciones a la
// derecha. No agrega estilos propios.

import type { ReactNode } from "react";

export type PageHeaderProps = {
  /** Micro-label mono en mayúsculas (el CSS las pone), p. ej. «Administración». */
  eyebrow?: string;
  title: ReactNode;
  sub?: ReactNode;
  /**
   * Botones a la derecha. Máx. 1 botón primario (`btn--primary`) por
   * pantalla, regla de la casa: el resto van `btn--secondary`/`ghost`.
   * Cada botón lleva su `title` con la frase de lo que hace.
   */
  actions?: ReactNode;
  /** id del <h1>, para un aria-labelledby o para mover el foco al título. */
  titleId?: string;
};

export function PageHeader({ eyebrow, title, sub, actions, titleId }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header__lead">
        {eyebrow && <div className="page-header__eyebrow">{eyebrow}</div>}
        <h1 id={titleId} className="page-header__title">
          {title}
        </h1>
        {sub && <p className="page-header__sub">{sub}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}
